import axios from "axios";
import {getApiLink} from "../functions/getApiLink";
import getCookies from "../functions/getCookie";
import setCookie from "../functions/setCookie";
import {setAccessToken, setUser} from "../storage/toolkit";
import {useNavigate} from "react-router-dom";
import {getBearer} from "../functions/getBearer";

export const GetAccessToken = (dispatch: any, callbackFunction?: any) => {

    if(window.location.href.includes("login")) return;

    const cookies = getCookies("refresh_token_ces");
    if (!cookies) {
        // Немає refresh токена - перенаправляємо на логін
        if(!window.location.href.includes("login") && !window.location.pathname.includes("reset-password")) {
            window.location.href = "/login";
        }
        return;
    }

    getBearer("post")
    axios.post(getApiLink("/api/auth/refresh/"), {
        "refresh_token": cookies
    }).then(({data}) => {

        setCookie("access_token_ces", data.access_token)
        dispatch(setUser(data.user))
        dispatch(setAccessToken(data.access_token))
        
        // Оновлюємо axios headers з новим токеном
        axios.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;

        // Викликаємо callback БЕЗ перезавантаження сторінки
        if (callbackFunction) {
            callbackFunction();
        }

    }).catch(er => {
        if(window.location.href.includes("login") || window.location.pathname.includes("reset-password")) return;

        window.location.href = "/login"
    })

}